import React from 'react'
import { useCallback } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import traiwissLogo from 'src/assets/traiwiss_logo.png'
import styled from 'styled-components'

const LoginForm = React.lazy(() => loadComponent('orga', 'LoginForm'))

const StyledImage = styled.img`
    width: 50%;
`

export function LoginRoute() {
    const navigate = useNavigate()
    let [searchParams] = useSearchParams()
    const onLogin = useCallback(() => {
        navigate('/')
    }, [navigate])

    return <LoginForm header={<StyledImage src={traiwissLogo} alt="traiwiss logo" />} onLogin={onLogin} xKey={searchParams.get('xkey')} />
}
